import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["input", "field"]
  static values = {
    callbacks: Object,
    enableTime: Boolean,
    noCalendar: Boolean,
    dateFormat: String,
    time24hr: Boolean,
    monthSelectorType: String,
    customClasses: String,
    disabledWeekend: Boolean,
    minDate: String,
    maxDate: String,
  }

  connect() {
    const callbacks = this.buildCallbacks()
    const customClasses = this.customClassesValue
    const disabledWeekend = this.disabledWeekendValue || false

    flatpickr(this.element, {
      enableTime: this.enableTimeValue,
      noCalendar: this.noCalendarValue || false,
      dateFormat: this.dateFormatValue || "Y-m-d H:i",
      time_24hr: this.time24hrValue || false,
      disableMobile: true,
      monthSelectorType: this.monthSelectorTypeValue || 'dropdown',
      onReady: function (_selectedDates, _dateStr, instance) {
        if(customClasses){
          instance.calendarContainer.classList.add(customClasses)
        };
      },
      disable: [
        function(date) {
          if(!disabledWeekend) return false;

          return date.getDay() === 0 || date.getDay() === 6;
        }
      ],
      minDate: this.minDateValue,
      maxDate: this.maxDateValue,
      ...callbacks
    })
  }

  buildCallbacks() {
    if (!this.hasCallbacksValue || typeof this.callbacksValue !== "object") return {}

    return Object.entries(this.callbacksValue).reduce((acc, [key, val]) => {
      if (typeof val === "string") {
        acc[key] = this.createFunctionFromString(val)
      } else if (Array.isArray(val)) {
        acc[key] = val.map((fn) => this.createFunctionFromString(fn))
      }
      return acc
    }, {})
  }

  createFunctionFromString(fnString) {
    try {
      const cleaned = fnString.trim()

      // Standard function expression
      if (cleaned.startsWith("function")) {
        return new Function("return " + cleaned)()
      }

      // Arrow function: (a, b) => a + b
      const arrowMatch = cleaned.match(/^\(?(.+?)\)?\s*=>\s*(.+)$/)
      if (arrowMatch) {
        const [_, params, body] = arrowMatch
        return new Function(...params.split(/\s*,\s*/), `return ${body}`)
      }

      return () => {}
    } catch (error) {
      console.error("Flatpickr callback parse error:", error)
      return () => {}
    }
  }
}
